import { motion } from "framer-motion";

const variants = {
  initial: { opacity: 0, y: 18 },
  enter:   { opacity: 1, y: 0,   transition: { duration: 0.55, ease: [0.22, 1, 0.36, 1] } },
  exit:    { opacity: 0, y: -12, transition: { duration: 0.35, ease: [0.22, 1, 0.36, 1] } },
};

/**
 * PageTransition
 * Wrap each page component to get animated route changes.
 *
 * Usage:
 *   export default function MyPage() {
 *     return <PageTransition>…content…</PageTransition>;
 *   }
 */
export default function PageTransition({ children }) {
  return (
    <motion.div
      variants={variants}
      initial="initial"
      animate="enter"
      exit="exit"
    >
      {children}
    </motion.div>
  );
}